import { appSync, isAnyOf, startListening } from '@betty/toolkit/state';
import {
  fetchCategories,
  selectFavoriteCategoriesIds,
  updateGameInFavoriteCategories,
} from './categories.slice';
import { favoriteGame, unfavoriteGame } from '../games/games.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchCategories('authenticated'));
  },
});

startListening({
  matcher: isAnyOf(favoriteGame.pending, unfavoriteGame.rejected),
  effect: (action, { dispatch, getState }) => {
    const gameId = action.meta.arg;
    const favoriteCategoriesIds = selectFavoriteCategoriesIds(getState());

    dispatch(
      updateGameInFavoriteCategories({
        gameId,
        favoriteCategoriesIds,
        type: 'FAVORITE',
      }),
    );
  },
});

startListening({
  matcher: isAnyOf(unfavoriteGame.pending, favoriteGame.rejected),
  effect: (action, { dispatch, getState }) => {
    const gameId = action.meta.arg;
    const favoriteCategoriesIds = selectFavoriteCategoriesIds(getState());

    dispatch(
      updateGameInFavoriteCategories({
        gameId,
        favoriteCategoriesIds,
        type: 'UNFAVORITE',
      }),
    );
  },
});

// if favorite cateogry doesn't exist re-fetch the categories
startListening({
  actionCreator: favoriteGame.fulfilled,
  effect: (_, { dispatch, getState }) => {
    const favoriteCategoriesIds = selectFavoriteCategoriesIds(getState());

    if (!favoriteCategoriesIds.length) {
      dispatch(fetchCategories('authenticated'));
    }
  },
});
